export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8083.3f157141.jpg";